import axios from "axios";
import { CONFIG } from "../config";

//get setting
 export async function getCountries(vendor,lang) {
    var request = await axios.post(CONFIG.URL, {
      serviceId: '1222',
      vendorId: vendor,
      lang: lang
    });
    return request.data;
  }